module.exports = __webpack_public_path__ + "static/media/006.98b0aea1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/006.jpg
// module id = 353
// module chunks = 0